// Module that verify conditions for example for:
// - Field visibility
// - Field required
// - Step availability
// and others...

import { getObjectValue } from "../utils/utils.js";

// individual condition base class
class ConditionBase {
  constructor(config, model) {
    this.config = config;
    this.model = model;
  }

  // return True if individual condition is valid
  get is_valid() {
    return true;
  }
}

// verify condition based on model value
class ConditionModel extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    if (field_value == this.config.value) {
      return true;
    } else {
      return false;
    }
  }
}

class ConditionGreater extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    if (field_value > this.config.value) {
      return true;
    } else {
      return false;
    }
  }
}

class ConditionLessLength extends ConditionBase {
  get is_valid() {
    var field_length = getObjectValue(this.model, this.config.field).length;
    var value_field = getObjectValue(this.model, this.config.value_field);
    if (field_length < value_field) {
      return true;
    } else {
      return false;
    }
  }
}

class ConditionInList extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    var $this = this;
    if (field_value) {
      if (this.config.type == "object") {
        var condition_value = field_value.some(e => {
          var conditions = true;
          for (const [key, value] of Object.entries($this.config.values)) {
            if ((typeof e[key] == "undefined") | (e[key] != value)) {
              conditions = false;
              continue;
            }
          }
          return conditions;
        });
        return condition_value;
      } else if (field_value.includes(this.config.value)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}

class ConditionNotInList extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    var $this = this;
    if (field_value) {
      if (this.config.type == "object") {
        var condition_value = field_value.some(e => {
          var conditions = true;
          for (const [key, value] of Object.entries($this.config.values)) {
            if ((typeof e[key] == "undefined") | (e[key] != value)) {
              conditions = false;
              continue;
            }
          }
          return conditions;
        });
        if (condition_value) return false;
        else return true;
      } else if (field_value.includes(this.config.value)) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}

class ConditionLess extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    if (field_value < this.config.value) {
      return true;
    } else {
      return false;
    }
  }
}

class ConditionGreaterEqual extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    if (field_value >= this.config.value) {
      return true;
    } else {
      return false;
    }
  }
}

class ConditionLessEqual extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    if (field_value <= this.config.value) {
      return true;
    } else {
      return false;
    }
  }
}

// verify if at least one condition is valid
class ConditionOr extends ConditionBase {
  get is_valid() {
    var conditions = new Conditions(this.config.conditions, this.model);
    return conditions.is_any_valid;
  }
}

class ConditionAnd extends ConditionBase {
  get is_valid() {
    var conditions = new Conditions(this.config.conditions, this.model);
    return conditions.is_all_valid;
  }
}

class ConditionAny extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    if (field_value && field_value.length) {
      return true;
    } else {
      return false;
    }
  }
}

class ConditionNOR extends ConditionBase {
  get is_valid() {
    var field_value = getObjectValue(this.model, this.config.field);
    if (field_value != this.config.value) {
      return true;
    } else {
      return false;
    }
  }
}

// set of conditions
export class Conditions {
  constructor(config, model) {
    this.model = model;
    this.conditions_list = [];

    var $this = this;
    if (config) {
      config.forEach(function(condition_config) {
        var condition_instance = $this.get_condition_class(
          condition_config,
          model
        );
        if (condition_instance) {
          $this.conditions_list.push(condition_instance);
        }
      });
    }
  }

  get_condition_class(condition_config, model) {
    if (condition_config.name == "condition_model") {
      return new ConditionModel(condition_config, model);
    } else if (condition_config.name == "condition_nor") {
      return new ConditionNOR(condition_config, model);
    } else if (condition_config.name == "condition_or") {
      return new ConditionOr(condition_config, model);
    } else if (condition_config.name == "condition_any") {
      return new ConditionAny(condition_config, model);
    } else if (condition_config.name == "condition_and") {
      return new ConditionAnd(condition_config, model);
    } else if (condition_config.name == "condition_greater") {
      return new ConditionGreater(condition_config, model);
    } else if (condition_config.name == "condition_less") {
      return new ConditionLess(condition_config, model);
    } else if (condition_config.name == "condition_greater_equal") {
      return new ConditionGreaterEqual(condition_config, model);
    } else if (condition_config.name == "condition_less_equal") {
      return new ConditionLessEqual(condition_config, model);
    } else if (condition_config.name == "condition_in_list") {
      return new ConditionInList(condition_config, model);
    } else if (condition_config.name == "condition_not_in_list") {
      return new ConditionNotInList(condition_config, model);
    } else if (condition_config.name == "condition_less_length") {
      return new ConditionLessLength(condition_config, model);
    }
  }

  // return True conditions are valid
  get is_all_valid() {
    var is_valid = true;
    this.conditions_list.forEach(function(condition) {
      if (condition.is_valid == false) {
        is_valid = false;
        return;
      }
    });
    return is_valid;
  }

  // return True if at least one condition is valid
  get is_any_valid() {
    var is_valid = false;
    this.conditions_list.forEach(function(condition) {
      if (condition.is_valid == true) {
        is_valid = true;
        return;
      }
    });
    return is_valid;
  }
}
